import { useCallback, useEffect, useState } from 'react';
import { Methods, ContractNames } from '@airdao/bond-periphery';
import { BigNumber } from 'ethers';
import useBondPeripheryContracts from '../contexts/BondPeripheryContext/useBondPeriphery';
import { InfoDataProps } from './types';
import { useAccount } from 'wagmi';

const defaultInfoData = {
  lockAmount: BigNumber.from('0x00'),
  timeFrame: {
    startTime: BigNumber.from('0x00'),
    endTime: BigNumber.from('0x00'),
  },
  rewardParams: {
    rewardAPY: BigNumber.from('0x00'),
    tierMultiplier: BigNumber.from('0x00'),
  },
  stakingTokenDecimals: 18,
  stakingTokenAddress: '',
  stakingTokenBalance: BigNumber.from('0x00'),
};

const useGetInfo = () => {
  const contracts: any = useBondPeripheryContracts();
  const { address: account } = useAccount();
  const [data, setData] = useState<InfoDataProps>(defaultInfoData);
  const [stakingToken, setStakingToken] = useState<any>(null);

  useEffect(() => {
    if (contracts && contracts.getContractByName) {
      const stakeToken = contracts.getContractByName(
        ContractNames.StakingToken,
      );
      if (stakeToken) {
        setStakingToken(stakeToken);
      }
    }
  }, [contracts]);

  const fetchData = useCallback(async () => {
    if (account && contracts && stakingToken) {
      try {
        const [
          lockAmount,
          timeFrame,
          rewardParams,
          stakingTokenDecimals,
          stakingTokenAddress,
          stakingTokenBalance,
        ] = await Promise.all([
          Methods.stakingGetLockAmount(
            contracts,
            ContractNames.TWStaking,
            stakingToken.address,
            account,
          ),
          Methods.timeframeGetFrame(contracts, ContractNames.TimeFrameOracle),
          Methods.rewardFeederGetRewardParams(
            contracts,
            ContractNames.RewardFeeder,
            stakingToken.address,
            account,
          ),
          stakingToken.decimals(),
          stakingToken.address,
          stakingToken.balanceOf(account),
        ]);

        setData(prevState => ({
          ...prevState,
          lockAmount,
          timeFrame,
          rewardParams,
          stakingTokenDecimals,
          stakingTokenAddress,
          stakingTokenBalance,
        }));
      } catch (error) {
        console.error('An error occurred:', error);
      }
    }
  }, [account, contracts, setData, stakingToken]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, fetchData };
};

export default useGetInfo;
